import { formatDistanceToNow } from 'core/utils/date'

import { type Shipper, type ShipperDetail } from '../domain/shippers'

export function formatLastShipmentLabel(shipper: Shipper): string {
  if (!shipper.lastShipmentAt) {
    return 'No actions yet'
  }

  return `${formatDistanceToNow(shipper.lastShipmentAt)} ago`
}

export function formatShipperAddress(shipperDetail: ShipperDetail): string {
  return shipperDetail.address || ''
}

export function formatShipperLocation(shipperDetail: ShipperDetail): string {
  const cityState = [shipperDetail.city, shipperDetail.state].filter(Boolean).join(', ')
  const zip = shipperDetail.zipcode ? ` ${shipperDetail.zipcode}` : ''
  return `${cityState}${zip}`.trim()
}

export function mapShipperCountryToCountryFlag(country: string): string {
  switch (country.toLowerCase()) {
    case 'united states':
    case 'usa':
    case 'us':
      return '🇺🇸'
    case 'canada':
    case 'ca':
      return '🇨🇦'
    case 'mexico':
    case 'mx':
      return '🇲🇽'
    default:
      return '🌐'
  }
}
